import { LoadingSpinner } from 'app/components/ui/LoadingSpinner'
import { useGetSponsorRequest } from 'app/queries/sponsorRequests'
import { protectedRoutes } from 'app/routing/routes'
import React from 'react'
import { useErrorHandler } from 'react-error-boundary'
import { Redirect, useParams } from 'react-router-dom'

import { SponsorRequestForm } from './SponsorRequestForm'

export const SponsorRequestEdit = (): JSX.Element => {
  const { sponsorRequestId } = useParams<{
    sponsorRequestId: string
  }>()

  const {
    data: sponsorRequest,
    error,
    isLoading,
  } = useGetSponsorRequest({ sponsor_request_id: sponsorRequestId })

  useErrorHandler(error)

  if (isLoading) return <LoadingSpinner />

  if (sponsorRequest && sponsorRequest?.status !== 'draft') {
    return (
      <Redirect
        to={protectedRoutes.sponsorRequestShow.makeUrl(sponsorRequest.id)}
      />
    )
  }

  return <SponsorRequestForm isEdit={true} sponsorRequest={sponsorRequest} />
}
